import React from 'react';
import './faq.css';
import { Container, Row, Col, Accordion } from "react-bootstrap";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';


const Blc_Faq = (props) => {

    return (
        <section>
            <Container className="mt-4 text-center">
                <div className="mt-5 text-center">
                    <h2>{props.valFaqs.Fac_title}</h2>
                    <hr className="faq-hr" />
                    <h5 className="text-middle-pos">{props.valFaqs.Fac_description}</h5>
                </div>
                <Row className="padding-faq">
                    <Col>
                        <Accordion className="btn-title" defaultActiveKey="0" flush>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>{props.valFaqs.faq_questtion[0].fac_question}</Accordion.Header>
                                <Accordion.Body>
                                <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
                                    {props.valFaqs.faq_questtion[0].faq_answer}
                                    </ReactMarkdown>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>{props.valFaqs.faq_questtion[1].fac_question}</Accordion.Header>
                                <Accordion.Body>
                                <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
                                    {props.valFaqs.faq_questtion[1].faq_answer}
                                    </ReactMarkdown>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>{props.valFaqs.faq_questtion[2].fac_question}</Accordion.Header>
                                <Accordion.Body>
                                <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
                                    {props.valFaqs.faq_questtion[2].faq_answer}
                                    </ReactMarkdown>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>{props.valFaqs.faq_questtion[3].fac_question}</Accordion.Header>
                                <Accordion.Body>
                                <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
                                    {props.valFaqs.faq_questtion[3].faq_answer}
                                    </ReactMarkdown>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>{props.valFaqs.faq_questtion[4].fac_question}</Accordion.Header>
                                <Accordion.Body>
                                <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
                                    {props.valFaqs.faq_questtion[4].faq_answer}
                                    </ReactMarkdown>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>{props.valFaqs.faq_questtion[5].fac_question}</Accordion.Header>
                                <Accordion.Body>
                                <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
                                    {props.valFaqs.faq_questtion[5].faq_answer}
                                    </ReactMarkdown>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header>{props.valFaqs.faq_questtion[6].fac_question}</Accordion.Header>
                                <Accordion.Body>
                                <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
                                    {props.valFaqs.faq_questtion[6].faq_answer}
                                    </ReactMarkdown>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>

            <Container className="padding-faq py-5">
                <h2 className="text-center">{props.valFaqs.lower_tagone}</h2>
                <hr className="faq-hr" />
                <div>
                <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]} className="text-center">
                {props.valFaqs.lower_tagdescription}
                                    </ReactMarkdown>
                </div>
            </Container>
        </section>
    );
};

export default Blc_Faq